var exports = {
  "q": "GifIndicator.module__indicator___NEpwWG",
};

module.exports = exports;
